<template>
  <b-form autocomplete="off" id="source_submit" @submit="onSubmit">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <b-form>
          <b-form-group label="Название"
                        label-for="title">
            <b-form-input id="title"
                          size="sm"
                          type="text"
                          v-model="userGroup.item.title">
            </b-form-input>
            <span class=" alert-danger"
                  v-if="submitted && nameValidateMessage">{{ nameValidateMessage }}</span>
          </b-form-group>

          <b-form-group label-for="users">
            <v-select :options="availableUsers"
                      label="name"
                      required v-model="userGroup.item.users" multiple>
              <span slot="no-options">Совпадений не найдено.</span>
            </v-select>
          </b-form-group>
          <b-button type="submit" class="float-right"
                    v-on:click="onSubmit($event, true)"
                    variant="primary">Сохранить и выйти
          </b-button>
          <span class=" alert-danger" v-if="submitted && message">{{ message }}</span>
          <div class="form-errors"></div>
        </b-form>
      </div>
    </div>
    <div class="form-errors"></div>
  </b-form>
</template>
<script>
import UsersService from '../../../services/usersDataService'

export default {
  name: 'EditUserGroupModal',
  components: {
    UsersService: UsersService
  },
  props: {
    userGroup: {
      default: function () {
        return {
          title: null,
          users: [],
        }
      }
    },
  },
  data() {
    return {
      availableUsers: [],
      submitted: false,
      nameValidateMessage: null,
      message: null,
    }
  },
  methods: {
    onSubmit(evt, close) {
      evt.preventDefault();

      this.submitted = true;
      this.nameValidateMessage = null

      if (!this.validateName()) {
        evt.preventDefault();

        return;
      }

      let usersArray = [];

      if (this.userGroup.item.users && this.userGroup.item.users.length != 0) {
        this.userGroup.item.users.forEach(function (user) {
          usersArray.push(user.id)
        });
      } else {
        usersArray = null
      }

      let data = {
        id: this.userGroup.item.id,
        title: this.userGroup.item.title,
        users: usersArray,
      }

      UsersService.editUserGroup(data)
          .then(function (response) {
            if (response) {
              this.nameValidateMessage = null

              if (response.error) {
                if (response.error == 'group_exists') {
                  this.message = 'Группа с таким названием уже существует.';
                } else {
                  this.message = 'Произошла ошибка.';
                }

                return;
              }

              window.location.href = '/user-groups';
            }
          }.bind(this))
    },
    validateName() {
      if (!this.userGroup.item.title) {
        this.nameValidateMessage = 'Поле Название является обязательным.'

        return false;
      }

      return true;
    },
    getAvailableUsers() {
      UsersService.getAvailableUsersForGroups()
          .then(users => {
            this.availableUsers = users
          })
    }
  },
  beforeMount() {
    this.getAvailableUsers()
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditUserGroupModal.vue